import React, {Component} from 'react';
import AppearanceContext from '../context/AppearanceContext';

let stepIndex = 0;

const BookingStepHOC = (C) => {
  let currentStep;

  class BookingStep extends Component {
    componentWillMount() {
      this.increaseCount();
    }

    componentWillReceiveProps() {
      this.increaseCount();
    }

    /* eslint-disable class-methods-use-this */
    increaseCount() {
      currentStep = ++stepIndex;
    }
    /* eslint-enable class-methods-use-this */

    render() {
      return (
<AppearanceContext.Consumer>
        {data => <C {...this.props} stepIndex={currentStep || 0} stepTotal={data.totalSteps || 0} />}
</AppearanceContext.Consumer>
      );
    }
  }

  return BookingStep;
};

export const flushStepCounter = () => stepIndex = 0; // eslint-disable-line no-return-assign

export default BookingStepHOC;
